import React from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@material-ui/core";

const DrawerTable = ({
  title,
  headers,
  isEmpty: empty,
  emptyMessage = "No Records Found",
  children,
}) => (
  <section className="drawer-section">
    <h2 className="drawer-section-title">{title}</h2>
    <TableContainer
      component={Paper}
      className="content-finder-table-container drawer-table-container"
    >
      <Table className="content-finder-table content-finder-table--no-scroll">
        <TableHead className="tableHeader content-finder-table-head">
          <TableRow className="tableRow content-finder-header-row">
            {headers.map((header, i) => (
              <TableCell key={i} className="media-cell">
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody className="content-finder-table-body">
          {empty ? (
            <TableRow className="tableRow content-finder-body-row">
              <TableCell
                className="content-finder-table-cell drawer-empty-cell"
                colSpan={headers.length}
              >
                {emptyMessage}
              </TableCell>
            </TableRow>
          ) : (
            children
          )}
        </TableBody>
      </Table>
    </TableContainer>
  </section>
);

export default DrawerTable;
